<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav ChildrenMenu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
      <!-- <b-link
        tooltip.hover
        :href="storeUrl"
        target="_blank"
        title="Ir para a sua loja"
        class="ml-2"
      >
        <feather-icon
          icon="ShoppingBagIcon"
          size="21"
          class="text-primary"
        />
      </b-link> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <notification-dropdown-list /> -->
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.cliente.nome }}
            </p>
            <span class="user-status">{{ userData.role }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="userData.foto_perfil"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="openUpdateModal"
        >
          <!-- @click="openUpdateModal" -->
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Meu Perfil</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="openChangePasswordPage"
        >
          <feather-icon
            size="16"
            icon="LockIcon"
            class="mr-50"
          />
          <span>Alterar Senha</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <user-update-modal
      :modal-id="'update-user-profile'"
      :user-data="userData"
      @hidden="handleModalHidden"
    />
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import useJwt from '@/auth/jwt/useJwt'
import UserUpdateModal from '@core/layouts/components/app-navbar/components/UserUpdateModal.vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
    UserUpdateModal,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {
      },
    },
  },
  data() {
    return {
      nameRoles: {
        Admin: 'Administrador',
        client: 'Cliente',
      },
    }
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    storeUrl() {
      const mode = process.env.MODE_APP || process.env.VUE_APP_MODE_APP
      const baseUrl = mode === 'prod'
        ? 'https://avmarket.com.br'
        : 'https://hml.avmarket.com.br/'
      const vendedorId = this.userData?.vendedor?.id
      return vendedorId ? `${baseUrl}/?v=${vendedorId}` : baseUrl
    },
  },
  methods: {
    openUpdateModal() {
      this.$bvModal.show('update-user-profile')
    },

    openChangePasswordPage() {
      this.$router.push({
        name: 'profile-settings',
        query: {
          tab: 'password',
        },
      })
    },

    handleModalHidden() {
      // Recarregar dados do usuário após atualização
      const userData = JSON.parse(localStorage.getItem('userData'))
      if (userData) {
        this.userData = userData
      }
    },
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')
      localStorage.clear()
      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>
